/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q3_AnswerInputs */

const en_home_faq_q3_answer = /** @type {(inputs: Home_Faq_Q3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access policy documents, manage travellers, connect with support, view travel resources, submit claims, and unlock additional services included with your coverage.`)
};

const fr_home_faq_q3_answer = /** @type {(inputs: Home_Faq_Q3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accédez à vos documents de police, gérez les voyageurs, contactez le soutien, consultez les ressources de voyage, soumettez des réclamations et débloquez les services supplémentaires inclus dans votre couverture.`)
};

/**
* | output |
* | --- |
* | "Access policy documents, manage travellers, connect with support, view travel resources, submit claims, and unlock additional services included with your cov..." |
*
* @param {Home_Faq_Q3_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q3_answer = /** @type {((inputs?: Home_Faq_Q3_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q3_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q3_answer(inputs)
	return fr_home_faq_q3_answer(inputs)
});